import { Link, useRouteError, isRouteErrorResponse } from "react-router";

import styles from "./route-error.module.scss";

export function RouteError() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <div className={styles.page}>
        <div className={styles.title}>Page not found</div>
        <div className={styles.description}>
          The page you're looking for doesn't exist or has been moved.
        </div>
        <Link to="/today" className={styles.link}>
          Go to today
        </Link>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.title}>Something went wrong</div>
      <div className={styles.description}>
        An unexpected error occurred. Try refreshing the page.
      </div>
      <Link to="/today" className={styles.link}>
        Go to today
      </Link>
    </div>
  );
}
